var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.333,
    height: 40,
    viewBox: "0 0 53.333 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image_default",
    transform: "translate(0 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M12,10.5a6,6,0,1,0,6,6,6,6,0,0,0-6-6Zm-2,6a2,2,0,1,1,2,2A2,2,0,0,1,10,16.5Z",
    transform: "translate(3.185 3.333)",
    fill: "#b1b1b1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    d: "M6.667,4.5A6.667,6.667,0,0,0,0,11.167V37.833A6.667,6.667,0,0,0,6.667,44.5h40a6.667,6.667,0,0,0,6.667-6.667V11.167A6.667,6.667,0,0,0,46.667,4.5Zm40,4.444h-40a2.222,2.222,0,0,0-2.222,2.222V37.833a2.222,2.222,0,0,0,2.222,2.222h9.587L31.538,24.768a6.667,6.667,0,0,1,9.43,0l7.921,7.923V11.167A2.222,2.222,0,0,0,46.667,8.944Zm0,31.111H22.538L34.681,27.913a2.222,2.222,0,0,1,3.142,0L48.681,38.771A2.222,2.222,0,0,1,46.667,40.056Z",
    fill: "#b1b1b1",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.7a87e2c8ba4441fde7bd61d7da7faaa6.svg";
export { ForwardRef as ReactComponent };